/* @ngInject */
const trainLabels = () => {
  const self = {}

  self.class = 'Train'
  self.title = 'Trains'

  self.fields = {
    id: {
      text: 'Id du train',
    },
    arrival: {
      text: 'Arrivée',
    },
    departure: {
      text: 'Départ',
    },
    tractionnaire: {
      text: 'Tractionnaire',
    },
    date: {
      text: 'Date',
    },
    dateBegin: {
      text: 'Date du train',
    },
    dateEnd: {
      text: 'Jusqu\'au',
    },
    number: {
      text: 'Numéro du train',
    },
    wagonCount: {
      text: 'Nombre de wagon',
    },
  }

  self.statements = {
    unpark: 'Dégarer un train',
    scrap: 'Ferrailler des wagons',
    announce: 'Annoncer le ferraillage des wagons',
    edit: 'Modifier le train',
    createDeparture: 'Créer le train de départ',
    createScrapping: 'Créer le ferraillage',
    empty: 'Le train est actuellement vide',
    list: 'Liste des trains',
    search: 'Rechercher des trains',
    modify: 'Modifier le train',
    removeWagons: 'Retirer des wagons du train',
    addWagon: 'Ajouter des wagons au train',
    pullOut: 'Retirer',
    arrival: 'Arrivée',
    departure: 'Départ',
    label: (_size = 0, _point = false) => {
      return 'Train' + (_size > 1 ? 's' : '') + (_point ? ' : ' : '')
    },
    selected: (_selected = false) => {
      return _selected ? 'Train sélectionné' : 'Sélection du train'
    },
    wagonsRemoved: (_length) => {
      return 'Le' + (_length > 1 ? 's ' + _length + ' wagons ont été retirés ' : ' wagon a été retiré ') + 'du train'
    },
    entitled: (_tractionnaire, _date, _name) => {
      return _tractionnaire + ' - ' + _date + (_name ? ' - ' + _name : '')
    },
    getExisting: (_length) => {
      return 'Récupération d\'un train existant (' + _length + (_length > 1 ? ' wagons)' : ' wagon)')
    },
    getNew: 'Création d\'un nouveau train',
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer ce train ?',
    deleteWithWagons: 'Des wagons appartiennent encore à ce train, Êtes-vous sûr de vouloir le supprimer ?',
  }

  self.log = {
    save: {
      success: 'Le train a bien été créé.',
      failure: 'Une erreur est survenue lors de la création du train.',
    },
    update: {
      success: 'Le train a bien été modifié.',
      failure: 'Une erreur est survenue lors de la modification du train.',
    },
    delete: {
      success: 'Le train a bien été supprimé.',
      failure: 'Une erreur a interrompu la suppression du train.',
    },
    getWagons: {
      success: 'Les wagons du train ont bien été recherchés.',
      failure: 'Une erreur a interrompu la recherche des wagons de ce train.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun train ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 train a été trouvé.'
        } else if (_length > 1) {
          return _length + ' trains ont été trouvés.'
        }
        return 'Train recherché.'
      },
      failure: 'Une erreur est survenue durant la recherche des trains',
      noResult: 'Aucun train ne correspond à cette recherche',
    },
  }

  return self
}

export default trainLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/resources/labels.resource.js